import { render, staticRenderFns } from "./TemplateMenu.vue?vue&type=template&id=e6920b86"
import script from "./TemplateMenu.vue?vue&type=script&lang=js"
export * from "./TemplateMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports